module.exports = __webpack_public_path__ + "static/media/fleet_man.0fbce041.jpg";